import { observable, action } from 'mobx'
import api from '../api'

class UnsubscribeEmailStore {
  @observable email = undefined
  @observable errors = undefined

  @action.bound unsubscribe(email) {
    if(this.email) {
      return
    }
    this.email = email

    return api.User.unsubscribeEmail(this.email)
    .catch(action((err) => {
      this.errors = err
    }))
  }
}

export default new UnsubscribeEmailStore()



// WEBPACK FOOTER //
// ./src/stores/unsubscribeEmailStore.js